import React from "react";
import styles from "./CollaboratorRow.module.css";
import { CustomIconButton, icon } from "../../../../../../../common/components";

export default function CollaboratorRow({ id, collaborator, onRemove }) {
	return (
		<div className={styles.main}>
			<span>{collaborator}</span>
			<CustomIconButton icon={icon.faTimes} iconColor="var(--grey-600)" onClick={() => onRemove(id)} />
		</div>
	);
}
